import 'animate.css';
import {Form, Formik} from 'formik';
import styled from 'styled-components';
import {Button, Grid} from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';

import {Fields} from './Fields';
import Loading from '../Loading';
import {registerSteps} from '../SignIn';
import FormikContext from './FormikContext';
import {validationSchema} from './validation';
import useProvince from 'hooks/useProvince';
import CustomTextField from 'components/AddOrEditForm/fields/TextField';
import VerificationCodeInput from '../VerificationCode';
import TimerComponent from '../Timer';

const LoginForm = ({
  steps,
  actionHandler,
  isLoading,
  timerProps,
  initialValues,
  setInitialValues,
}) => {
  const {isScanCenter} = initialValues || {};
  const {data: province} = useProvince();
  

  const handleSubmit = (values) => {
    const {
      phone,
      code,
      firstName,
      lastName,
      cityId,
      address,
      provinceId,
      isScanCenter,
      scanCenterName,
    } = values || {};

    actionHandler(values);
    if (steps === registerSteps.sendloginCode) {
      setInitialValues((prev) => ({...prev, phone}));
    } else if (steps === registerSteps.login) {
      setInitialValues((prev) => ({...prev, code}));
    } else if (steps === registerSteps.signup) {
      setInitialValues((prev) => ({
        ...prev,
        firstName,
        lastName,
        isScanCenter,
        scanCenterName,
        provinceId,
        cityId,
        address,
      }));
    }
  };

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      validationSchema={validationSchema(steps, isScanCenter)}
      onSubmit={handleSubmit}>
      {(props) => {
        const provinceCities = province?.filter(
          (item) => item.id === props?.values?.provinceId
        )?.[0]?.cities;

        let formIsValid =
          steps === registerSteps.signup
            ? props.isValid && props.dirty
            : props.isValid;

        if (steps === registerSteps.sendloginCode) {
          formIsValid = props.values?.['phone']?.length === 11;
        }

        return (
          <Form>
            <FormikContext handleSubmit={handleSubmit} steps={steps} />
            <Grid container spacing={'14px'}>
              <Grid item xs={12}>
                {registerSteps.sendloginCode === steps && (
                  <CustomTextField
                    icon={<PersonIcon sx={{mt: '5px'}} />}
                    name='phone'
                    type='number'
                    placeholder='شماره تماس'
                    showValueCenter
                    {...props}
                  />
                )}
              </Grid>
              {registerSteps.login === steps && (
                <Grid item xs={12}>
                  <VerificationCodeInput length={4} name='code' {...props} />
                  <TimerComponent {...timerProps} />
                </Grid>
              )}
              <Fields
                {...props}
                steps={steps}
                province={province}
                provinceCities={provinceCities}
                isAgent={isScanCenter ? false : true}
              />
            </Grid>
            <StyledButton type='submit' steps={steps} disabled={!formIsValid}>
              {isLoading ? (
                <Loading />
              ) : (
                <span>
                  {steps === registerSteps.sendloginCode ? 'ورود' : 'ثبت'}
                </span>
              )}
            </StyledButton>
          </Form>
        );
      }}
    </Formik>
  );
};

export default LoginForm;

const StyledButton = styled(Button)`
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  font-size: 18px !important;
  font-weight: 700 !important;
  margin: ${({steps}) =>
    steps === registerSteps.signup
      ? '25px auto 30px !important'
      : '98px auto 0 !important'};
  padding: 0 !important;
  border-radius: 50% !important;
  width: 80px;
  height: 80px;
  background: #f5f5f5;
  border: 1px solid #ffffff !important;
  box-shadow: 15px 15px 25px rgba(172, 172, 172, 0.5), -15px -15px 25px #fff;
`;
